import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/** Rol ekle/düzenle form şeması (020): nameTr zorunlu; nameEn/açıklamalar opsiyonel. */
export const roleFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
  descriptionTr: optionalText(),
  descriptionEn: optionalText(),
})

export type RoleFormValues = z.infer<typeof roleFormSchema>
